import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonLock20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPersonLock20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.6 4.5a2 2 0 0 1 2 2h1.5a3.5 3.5 0 1 0-5.834 2.608A5.6 5.6 0 0 0 3 14.2V17h4.9v-1.5H4.5v-1.3a4.1 4.1 0 0 1 3.4-4.04V8.374A2 2 0 0 1 8.6 4.5m7 5.5-.002-.1A2.8 2.8 0 0 0 10 10v.254A2.5 2.5 0 0 0 8.6 12.5v2a2.5 2.5 0 0 0 2.5 2.5h3.4a2.5 2.5 0 0 0 2.5-2.5v-2a2.5 2.5 0 0 0-1.4-2.246zm-2.8-1.3a1.3 1.3 0 0 0-1.296 1.2h2.592A1.3 1.3 0 0 0 12.8 8.7m-1.7 2.8h3.4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1m2.4 2a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonLock20);
